// screens/HomePage.tsx
import React from 'react';
import notificationIcon from '../assets/icons/UltimaLogoNew.png';
import Layout from '@/sections/core/Layout';
import { useSession } from '@/contexts/AuthContext';

const HomePage: React.FC = () => {

  const { user, status } = useSession();

  console.log(user, status);
  console.log("HomePage.tsx");
  function showNotification() {
    new Notification('Title of Notification', {
      body: 'This is the body of the notification.',
      icon: notificationIcon,
    });
  }

  return (
    <Layout>
      {user?.username || 'no'}
      <button onClick={showNotification}>
      Show Notification
      </button>
      <h1>Welcome to the Home Page</h1>
      <p>This is the main landing page of your Electron-React application.</p>
    </Layout>
  );
};

export default HomePage;
